import http from './httpServ'
// import md5 from 'blueimp-md5'
import cache from './cacheServ'
class User {

  /**
   * 通过微信code快速登录
   *
   * @param {any} code
   * @returns
   * @memberof User
   */
  loginByCode (code) {
    return http.post(
      `/lease/authorization?code=${code}`
    ).then(res => {
      if (res.code === '200') {
        cache.set('user', res.data, true)
        return Promise.resolve(res)
      }
      return Promise.reject(0)
    })
  }

  /**
   * 检测是否登录
   *
   * @returns
   * @memberof User
   */
  isLogin () {
    const user = cache.get('user')
    if (!user) {
      return false
    }
    return true
  }

    /**
     * 判断是微信还是支付宝进入
     * @returns {*}
     * @constructor
     */
    IsWeixinOrAlipay(){
        var ua = window.navigator.userAgent.toLowerCase();
        //判断是不是微信
        if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {
            return "WeiXIN";
        }
        //判断是不是支付宝
        if (ua.match(/AlipayClient/i) == 'alipayclient') {
            return "Alipay";
        }
        //哪个都不是
        return "false";
    }

    /**
     * 支付宝登录 获取用户信息
     * @returns {any|Promise<U>}
     */
    zfbLoginByCode (code) {
        return http.post(
            `/zfb/lease/authentication?code=${code}`
        ).then(res => {
            if (res.code === '200') {
                cache.set('user', res.data, true)
                return Promise.resolve(res)
            }
            return Promise.reject(0)
        })
    }

}

export default new User()



// WEBPACK FOOTER //
// ./src/service/userServ.js